import { apiClient } from "../apiClient";
import {
  BACKEND_ENDPOINTS,
  CASE_LAW_ENDPOINTS,
  STATUTE_SEARCH_ENDPOINTS,
} from "../apiEndpoints";

export const fetchBookmarkGroupsApi = async (userId) => {
  const response = await apiClient.get(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.GET_BOOKMARK_GROUPS}?userId=${userId}`
  );
  if (response.status !== 200) {
    throw new Error("Failed to fetch bookmark groups");
  }
  return response.data;
};

export const renameGroupApi = async (userId, groupId, newGroupName) => {
  const response = await apiClient.put(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.RENAME_BOOKMARK_GROUP}`, {
    userId,
    groupId,
    newGroupName,
  });

  if (response.status !== 200) {
    throw new Error("Failed to rename the group");
  }

  return response.data;
};

export const deleteGroupApi = async (userId, groupId) => {
  const response = await apiClient.delete(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.DELETE_BOOKMARK_GROUP}`, {
    userId,
    groupId,
  });

  if (response.status !== 200) {
    throw new Error("Failed to delete the group");
  }

  return response.data;
};

export const createNewGroupApi = async (userId, groupName) => {
  const response = await apiClient.post(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CREATE_BOOKMARK_GROUP}`, {
    userId,
    groupName,
  });

  if (response.status !== 201) {
    throw new Error("Failed to rename the group");
  }

  return response.data;
};

export const fetchCasesApi = async (filter) => {
  const response = await apiClient.post(`${BACKEND_ENDPOINTS.SEARCH_BASE_URL}${CASE_LAW_ENDPOINTS.SEARCH}`, {
    count: "true",
    mode: "keyword",
    search: "",
    filter: filter,
    top: 100,
    skip: 0,
    orderby: "",
  });

  if (response.status !== 200) {
    throw new Error("Failed to fetch cases from Azure Search.");
  }
  const data = response.data;
  return data?.value;
};

export const fetchStatutesApi = async (filter) => {
  const azureStatuteSearch = `${BACKEND_ENDPOINTS.SEARCH_BASE_URL}${STATUTE_SEARCH_ENDPOINTS.SEARCH}`;
  const response = await apiClient.post(azureStatuteSearch, {
    query: "",
    sort_by: "",
    filter: filter,
    search_field_mode: "Title",
    top: 100,
    skip: 0,
    count: true,
  });

  if (response.status !== 200) {
    throw new Error("Failed to fetch statutes from Azure Search.");
  }
  const data = response.data;
  return data?.search_results;
};

export const updateNoteApi = async (userId, groupId, itemId, itemType, note) => {
  const url = `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.UPDATE_NOTE}`;
  try {
    const response = await apiClient.put(url, {
      userId,
      groupId,
      itemId,
      itemType,
      note,
    });

    if (response.status !== 200) {
      throw new Error("Failed to update note");
    }

    return response.data;
  } catch (error) {
    console.error("Error updating note:", error);
    throw error;
  }
};

export const removeNoteApi = async (userId, groupId, itemId, itemType) => {
  const url = `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.REMOVE_NOTE}`;
  try {
    const response = await apiClient.put(url, {
      userId,
      groupId,
      itemId,
      itemType,
    });

    if (response.status !== 200) {
      throw new Error("Failed to remove note");
    }

    return response.data;
  } catch (error) {
    console.error("Error removing note:", error);
    throw error;
  }
};

export const addCaseToGroupApi = async (payload) => {
  const response = await apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.ADD_CASE_TO_GROUP}`,
    payload
  );
  return response;
};

export const addStatuteToGroupApi = async (payload) => {
  const response = await apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.ADD_STATUTE_TO_GROUP}`,
    payload
  );
  return response;
};

export const createBookmarkGroupApi = async (payload) => {
  const response = await apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CREATE_BOOKMARK_GROUP}`,
    payload
  );
  return response;
};

export const removeItemFromGroupApi = async (userId, groupId, caseId, statuteId) => {
  const payload = { userId, groupId };
  if (caseId) payload.caseId = caseId;
  if (statuteId) payload.statuteId = statuteId;
  const response = await apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.DELETE_CASE_OR_STATUTE_FROM_GROUP}`,
    payload
  );
  return response;
};

// Used by StatuteSearch — preserving original URL path exactly
export const removeStatuteFromCaseGroupApi = async (userId, groupId, statuteId) => {
  const response = await apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/deleteCaseOrStatuteFromGroup`,
    { userId, groupId, statuteId }
  );
  return response;
};

export const fetchCmsDocsByIdsApi = async (docs) => {
  const response = await apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_DOCUMENTS_BY_IDS}`,
    { docs }
  );
  if (response.status !== 200) throw new Error("Failed to fetch CMS documents");
  return response.data;
};

export const removeCmsDocFromGroupApi = async (userId, groupId, docId) => {
  const response = await apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.DELETE_CMS_DOC_FROM_GROUP}`,
    { userId, groupId, docId }
  );
  return response;
};

export const copyBookmarkApi = async (userId, fromGroupId, toGroupId, caseId, statuteId) => {
  try {
    const payload = { userId, fromGroupId, toGroupId, caseId, statuteId };

    const response = await apiClient.post(
      `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.MOVE_CASE_OR_STATUTE_BETWEEN_GROUPS}`,
      payload
    );

    if (response.status !== 200) {
      console.log("Response is not ok");
      throw new Error("Failed to copy bookmark");
    }
    return response.data;
  } catch (error) {
    throw new Error(error.message || "Error copying bookmark");
  }
};
